import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay,EffectCoverflow,Navigation,Pagination,Scrollbar,A11y } from 'swiper/modules';
import Card from './Card';
import 'swiper/css';

import { Link } from 'react-router-dom';
const Splider = ({products,category,type}) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    if(products.length<=0) return <></>
    else
    return (
        <div className='container mx-auto' style={{ margin:'30px 0' }}>
            <div className='slider-header'> 
            <div className='slider-button'>
                <div className='d-none d-md-flex'>
                <i className='fa-solid fa-chevron-right ' ref={prevRef}></i>
                <i className='fa-solid fa-chevron-left ' ref={nextRef}></i>
                </div>
                <div className='show-all'>
                  {type==='products_main_categories'?(
                    <Link to={`/main_category/${category.id}/${category.name}`}  >عرض الكل</Link>
                  ):(
                    <Link to={`/category/${category.id}/${category.name}/${category.main_category_id}`}>عرض الكل</Link>
                  )}
                </div>
            </div>
            <div className='slider-cat'>
                <h3>{category.name}</h3>
            </div>
            </div>
              

        <Swiper 
        modules={[Autoplay,EffectCoverflow,Navigation,Pagination,A11y,Scrollbar]}    
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
          reverseDirection : false,
          delayBetweenSlides: 0,
          paused:false
        }}
    
        spaceBetween={20}
        slidesPerGroup={1}
        speed={200}
      
        loop={true}
        slidesPerView='auto'
        centeredSlides={true}  
        breakpoints={{
       
          768: {
            centeredSlides:false 
          },
        }}
        navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }}
       
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
     }}
      >
        {products.map((product,idx)=>(
          <SwiperSlide  style={{width:' 300px',height: '100%',borderRadius: '5px'}} key={idx}>
            <Card product={product}/>
          </SwiperSlide>
        ))}
        
      </Swiper>  
        </div>
      
      );
}

export default Splider
